require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-6-reasons-why-you-need-an-hsa-asap.json") })
        }
      }, "path---articles-6-reasons-why-you-need-an-hsa-asap");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-6-reasons-why-you-need-an-hsa-asap!./.cache/json/articles-6-reasons-why-you-need-an-hsa-asap.json
// module id = 1550
// module chunks = 231608221292675